export class BubbleDrawer {
    draw(data) {
        const { context, radius } = data;
        context.beginPath();
        context.arc(radius / 3, -radius / 3, radius / 3, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStyle = "#fff9";
        context.fill();
    }
}
